import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerDetails, EditCustomerReq } from '../models/company-setting.modals';
import { HttpRoutingService } from '../../common/services/http-routing.service';
import { ApiResponse, Documents, IdName } from '../../common/models/common.model';

@Injectable({
  providedIn: 'root'
})
export class CompanySettingService {
  /**
   * Service constructor to inject the other needed services here.
   * @param http Service to send the api request to the server.
   */
  constructor(private http: HttpRoutingService) { }
  /**
   * Method which is used to get current customer details from the database.
   * @return {Observable<ApiResponse<CustomerDetails>>}
   */
  getCustomerDetails(): Observable<ApiResponse<CustomerDetails>> {
    return this.http.getMethod('getCustomerDetails') as Observable<ApiResponse<CustomerDetails>>;
  }
  /**
   * Method which is used to fetch industry details.
   * @return {Observable<ApiResponse<IdName[]>>}
   */
  getIndustryDetails(): Observable<ApiResponse<IdName[]>> {
    return this.http.getMethod('getIndustryDetails') as Observable<ApiResponse<IdName[]>>;
  }
  /**
   * Method which is used to fetch timezone details.
   * @return {Observable<ApiResponse<IdName[]>>}
   */
  getTimezoneDetails(): Observable<ApiResponse<IdName[]>> {
    return this.http.getMethod('getTimezoneDetails') as Observable<ApiResponse<IdName[]>>;
  }
  /**
   * Method which is used to upload logo.
   * @param data The data which holds image name and image url.
   * @return {Observable<ApiResponse<null>>}
   */
  uploadLogo(data: Documents): Observable<ApiResponse<null>> {
    return this.http.postMethod('uploadLogo', data) as Observable<ApiResponse<null>>;
  }
  /**
   * Method which is used to remove company logo.
   * @return {Observable<ApiResponse<null>>}
   */
  removeCompanyLogo(): Observable<ApiResponse<null>> {
    return this.http.getMethod('removeCompanyLogo') as Observable<ApiResponse<null>>;
  }
  /**
   * Method which is used to edit the existing customer information with the provided information.
   * @param data which holds the customer information to be updated.
   * @return {Observable<ApiResponse<null>>}
   */
  editCustomerDetails(data: EditCustomerReq): Observable<ApiResponse<null>> {
    return this.http.postMethod('editCustomerDetails', data) as Observable<ApiResponse<null>>;
  }
  /**
   * Method which is used to generate new accessKey and secretKey for the customer.
   * @return {Observable<ApiResponse<{ accessKey: string; secretKey: string }>>}
   */
  generateApiKeys(): Observable<ApiResponse<{ accessKey: string; secretKey: string }>> {
    return this.http.postMethod('generateApiKeys', {}) as Observable<ApiResponse<{ accessKey: string; secretKey: string }>>;
  }
}
